import controller from './onlinePayWithAlipay.controller';
import template from './onlinePayWithAlipay.html';

const OnlinePayWithAlipayDetailsComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default OnlinePayWithAlipayDetailsComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/services/onlinePayWithAlipay/onlinePayWithAlipay.component.js
 **/